if (!String.prototype.includes) {
    String.prototype.includes = function (search) {
        return this.indexOf(search) > -1;
    };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, rawPos) {
            let pos = rawPos > 0 ? rawPos | 0 : 0;
            return this.substring(pos, pos + search.length) === search;
        },
    });
}

String.prototype.capitalize = function () {
    return this.length ? this[0].toUpperCase() + this.substring(1).toLowerCase() : '';
};
